var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vat-input',{attrs:{"value":_vm.value},on:{"adjustNet":_vm.emitUpdatedNet,"adjustGross":_vm.emitUpdatedGross}})}
var staticRenderFns = []

export { render, staticRenderFns }